

    require('../coord/parallel/parallelCreator');
    require('./axis/parallelAxisAction');
    require('./axis/ParallelAxisView');




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/parallelAxis.js
// module id = 1259
// module chunks = 158